import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";
import { DataService } from "src/app/data.service";

@Component({
  selector: "app-sectionrootlist",
  templateUrl: "./sectionrootlist.component.html",
  styleUrls: ["./sectionrootlist.component.scss"],
})
export class SectionrootlistComponent implements OnInit {
  isLoading = false;
  isError = false;
  errorMessage = "";
  mode = "";
  displayedColumns: string[] = ["action", "name", "type"];
  dataSource = "";
  sectionroot: any;
  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }
  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.getSectionRoot();
  }

  cancel() {
    this.router.navigateByUrl("/home");
  }
  new() {
    this.router.navigateByUrl("/home/sectionroot/new");
  }
  editApp(element: any) {
    this.router.navigateByUrl(
      "/home/sectionroot/edit/" + element.id + "/" + element.type
    );
  }

  delete(id: number) {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );
    const confirmDelete = window.confirm("Are you sure you want to delete?");

    if (!confirmDelete) {
      return;
    }
    this.isLoading = true;
    this.dataService.deleteSectionRoot(organizationid,id, domain, subdomain).subscribe(
      (res) => {
        // alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          // alert("Are you sure?")

          this.showSuccess(res.message);
          this.isLoading = false;

          window.location.reload();
        } else {
          console.log("Failed to delete!");
          this.isLoading = false;
          this.showError(res.message);
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        this.showError(err.message);
      }
    );
  }

  getSectionRoot() {
    return new Promise((resolve, reject) => {
      console.log("getSectionRoot");

      // alert(id)
      const organizationid = localStorage.getItem("crm_orgid");
      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );
      this.isLoading = true;
      this.dataService
        .getAllSectionRoot(domain, subdomain, organizationid)
        .subscribe(
          (res) => {
            console.log("res", res);

            if (res.success == 1) {
              this.sectionroot = res.data.sectionroot;
              console.log("Doneeee****", this.sectionroot);

              if (this.sectionroot != null) {
                this.dataSource = this.sectionroot.map((item) => ({
                  id: item.id,
                  // label: item.labelname,

                  name: item.name,
                  type: item.type.charAt(0).toUpperCase() + item.type.slice(1),
                }));
              }

              this.isLoading = false;
            } else {
              console.log("Error while retrieving");
              this.isLoading = false;
            }
          },
          (err) => {
            console.log("Error***:", err);
            this.errorMessage = err.message;
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        );
    });
  }
}
